import { msg } from '@lingui/core/macro';
import { EventPlaceholder } from 'modules/overlay-canvas/types/placeholders/create-argument';
import type { MessageDescriptor } from 'shared/i18n/i18n';

interface IItem extends EventPlaceholder {
  /** Подпись кнопки в меню. `blockText` — текст объекта на канве, он сохраняется в табло и не переводится. */
  listName: MessageDescriptor;
}

export const eventPlaceholderList: IItem[] = [
  {
    indicator: 'playerName',
    blockText: 'ФИО игрока',
    listName: msg`ФИО игрока`,
    type: 'text',
    playerIndex: 0,
  },
  {
    indicator: 'playerAvatar',
    blockText: 'Аватар игрока',
    listName: msg`Аватар игрока`,
    type: 'image',
    playerIndex: 0,
  },
  {
    indicator: 'playerNumber',
    blockText: 'Номер игрока',
    listName: msg`Номер игрока`,
    type: 'text',
    playerIndex: 0,
  },
  {
    indicator: 'playerRedCardCount',
    blockText: 'Количество красных карточек',
    listName: msg`Количество красных карточек`,
    type: 'text',
    playerIndex: 0,
  },
  {
    indicator: 'playerYellowCardCount',
    blockText: 'Количество жёлтых карточек',
    listName: msg`Количество жёлтых карточек`,
    type: 'text',
    playerIndex: 0,
  },
  {
    indicator: 'teamName',
    blockText: 'Название команды',
    listName: msg`Название команды`,
    type: 'text',
    teamReverse: false,
  },
  {
    indicator: 'teamShortName',
    blockText: 'Короткое название команды',
    listName: msg`Короткое название команды`,
    type: 'text',
    teamReverse: false,
  },
  {
    indicator: 'teamLogo',
    blockText: 'Логотип команды',
    listName: msg`Логотип команды`,
    type: 'image',
    teamReverse: false,
  },
  {
    indicator: 'score',
    blockText: 'Счёт команды',
    listName: msg`Счёт команды`,
    type: 'text',
    teamReverse: false,
  },
  {
    indicator: 'fouls',
    blockText: 'Фолы',
    listName: msg`Фолы`,
    type: 'text',
    teamReverse: false,
  },
  {
    indicator: 'currentPeriod',
    blockText: 'Текущий тайм',
    listName: msg`Текущий тайм`,
    type: 'text',
  },
  {
    indicator: 'eventMinute',
    blockText: 'Минута события',
    listName: msg`Минута события`,
    type: 'text',
  },
  {
    indicator: 'playerShootoutGoalCount',
    blockText: 'Голы игрока в серии пенальти',
    listName: msg`Голы игрока в серии пенальти`,
    type: 'text',
    playerIndex: 0,
  },
  {
    indicator: 'playerShootoutMissCount',
    blockText: 'Промахи игрока в серии пенальти',
    listName: msg`Промахи игрока в серии пенальти`,
    type: 'text',
    playerIndex: 0,
  },
  {
    indicator: 'teamShootoutGoals',
    blockText: 'Голы команды в серии пенальти',
    listName: msg`Голы команды в серии пенальти`,
    type: 'text',
    teamReverse: false,
  },
  {
    indicator: 'teamShootoutMisses',
    blockText: 'Промахи команды в серии пенальти',
    listName: msg`Промахи команды в серии пенальти`,
    type: 'text',
    teamReverse: false,
  },
];
